<!--
 * @Author: your name
 * @Date: 2021-10-29 15:42:35
 * @LastEditTime: 2021-11-16 15:00:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \adminCRM\src\components\customerCheck\customerLabel.vue
-->
<template>
<div id="customerCarInfo" class="container">
    <div v-for="(chunk,index) in customer" :key="index">
        <div class='tagTitle'>
          <el-tag type='info'  :closable="closeKuHandle" @close="reomveType(chunk)">
            {{chunk.groupName}}:
          </el-tag>
        </div>
        <el-tag :key="t" v-for="(tag,t) in chunk.corpTags" :disable-transitions="false" :closable="closeKuHandle" @close="reomveZiLabel(tag.tagId)">
            {{tag.tagName}}
        </el-tag>
    </div>
    <div class="opretaBtn" v-if="!closeKuHandle">
        <el-button type="primary" @click="closeKuHandle = true">移除</el-button>
        <el-button @click="addSelectLabel">新增标签</el-button>
    </div>
    <div class="opretaBtn" v-else>
        <el-button type="primary" @click="saveLable">保存</el-button>
        <el-button @click="closeLable">取消</el-button>
    </div>
    <el-dialog title="添加企业标签" :visible.sync="labelVisible" width="1200px" :before-close="resetAdd">
     <el-form :model="addruleForm" ref="addruleForm" label-width="100px" class="demo-addruleForm">
          <el-form-item label="标签分类" prop="labeltype">
             <el-select v-model="addruleForm.labeltype" @change="changeType" placeholder="请选择">
              <el-button class="button-new-tag" size="small" @click="typeInput">+ 添加标签分类</el-button>
              <div class="container" v-if="showAddInput">
                <el-input placeholder="请输入内容" style="width:210px;" v-model="labelname" clearable></el-input>
                <el-button class="button-new-tag" size="small" @click="typeSubmitInput">确认</el-button>
              </div>
              <el-option
                v-for="item in customer"
                :key="item.groupName"
                :label="item.groupName"
                :value="item.groupId">
                <div class="typebox">
                  <div class="typeGroup">{{ item.groupName }}</div>
                  <div class="typeTag" v-if="item.corpTags.length>0"><small v-for="(tag,ind) in item.corpTags" :key="ind">{{ tag.tagName }}</small></div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签名称" prop="tagName">
            <el-tag
                :key="tag.tagId"
                v-for="tag in dynamicTags"
                closable
                :disable-transitions="false"
                @close="handleClose(tag)">
                {{tag.tagName}}
              </el-tag>
              <el-input
                class="input-new-tag"
                v-if="inputVisible"
                v-model="inputValue"
                ref="saveTagInput"
                size="small"
                @keyup.enter.native="handleInputConfirm"
                @blur="handleInputConfirm"
              >
            </el-input>
            <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加标签名称</el-button>
          </el-form-item>
          <el-form-item class="flexEnd">
            <el-button @click="resetAdd('addruleForm')">取消</el-button>
            <el-button type="primary" @click="submitAddForm('addruleForm')">保存</el-button>
          </el-form-item>
        </el-form>
    </el-dialog>
    <el-dialog title="是否确认删除" :visible.sync="deleteDialog" width="600px">
        <div>删除标签分类将会删除分类下所有标签，是否确认删除</div>
        <div slot="footer" class="dialog-footer">
            <small>*确认删除标签分类/标签后，历史已打此标签用户将不再展示此标签</small>
            <el-button @click="deleteDialog = false">取 消</el-button>
            <el-button type="primary" @click="deleteTypeHandle">确 认</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import http from '@/api/label';
export default {
  name: 'labelManage',
  props: ['mobile', 'update'],
  data () {
    return {
      customer: [],
      customerCopy: [],
      closeKuHandle: false,
      labelVisible: false,
      labelname: '',
      deleteDialog: false,
      group_id: '',
      addruleForm: {
        labeltype: '',
        tagName: ''
      },
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      labelTreeDialog: false,
      showCheckedKeys: [],
      showAddInput: false,
      groupArr: {}
    };
  },
  watch: {
    'update' () {
      // 先格式化data
    }
  },
  created () {
    this.getLabelList();
  },
  methods: {
    getLabelList () {
      http.userAllList().then((res) => {
        if (res.success) {
          this.customer = res.data;
        }
      });
    },
    reomveType (arr) {
      this.deleteDialog = true;
      this.groupArr = arr;
    },
    reomveZiLabel (tagId) {
      this.customer.map(item => {
        item.corpTags.map(Tags => {
          if (tagId === Tags.tagId) {
            item.corpTags.splice(item.corpTags.indexOf(Tags), 1);
          }
        });
      });
    },
    saveLable () {
      this.customer = JSON.parse(JSON.stringify(this.customer).replace(/corpTags/g, 'tag').replace(/tagId/g, 'id').replace(/tagName/g, 'name'));
      http.addLabelSave(this.customer).then((res) => {
        if (res.success) {
          this.showAddInput = false;
          let tipName = [];
          this.$message.success('操作成功!');
          this.getLabelList();
          if (res.data.length > 0) {
            res.data.forEach(item => {
              tipName.push(item.tagName);
            });
            this.$notify({
              title: '企业微信标签提示',
              message: '[' + tipName + '] 标签不可删除!'
            });
          }
        }
      });
      this.closeKuHandle = false;
      this.getLabelList();
    },
    closeLable () {
      this.closeKuHandle = false;
      this.getLabelList();
    },
    addSelectLabel () {
      this.labelVisible = true;
      this.showAddInput = false;
      this.inputVisible = false;
      this.addruleForm.labeltype = '';
      this.dynamicTags = [];
      this.customerCopy = this.customer;
    },
    // 删除分类弹窗提醒
    deleteTypeHandle () {
      this.customer.splice(this.customer.indexOf(this.groupArr), 1);
      this.deleteDialog = false;
      console.log('this.customer', this.customer);
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.customerCopy.map(item => {
        if (this.addruleForm.labeltype === item.groupId) {
          item.corpTags = this.dynamicTags;
        }
      });
    },
    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm () {
      if (this.inputValue == '') {
        this.inputVisible = false;
        return this.$message.warning('标签名称不可为空!');
      }
      if (!this.addruleForm.labeltype) {
        this.inputValue = '';
        return this.$message.warning('请先选择或新增标签分类!');
      }
      if (this.inputValue.trim()) {
        this.dynamicTags.map(s => {
          if (s.tagName == this.inputValue) {
            this.inputValue = '';
            return this.$message.warning('同分类标签名称不能相同!');
          }
        });
        if (this.inputValue) {
          this.dynamicTags.push({
            tagId: '',
            tagName: this.inputValue
          });
          this.customerCopy.map(item => {
            if (this.addruleForm.labeltype === item.groupId) {
              item.corpTags = this.dynamicTags;
            }
          });
        }
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    changeType () {
      console.log('addruleForm', this.addruleForm);
      this.customerCopy.map(item => {
        if (this.addruleForm.labeltype === item.groupId) {
          this.dynamicTags = item.corpTags;
        }
      });
      this.inputVisible = false;
    },
    typeInput () {
      console.log('新分类', this.labelname);
      this.labelname = '';
      this.showAddInput = true;
    },
    typeSubmitInput () {
      if (this.labelname) {
        this.customerCopy.map(item => {
          if (this.labelname === item.groupName) {
            this.labelname = '';
            return this.$message.warning('分类名称不能相同!');
          }
        });
        console.log('this.labelname', this.labelname);
        if (this.labelname) {
          this.customerCopy.push({
            groupId: this.labelname,
            groupName: this.labelname,
            corpTags: []
          });
          this.labelname = '';
          this.showAddInput = false;
        }
      } else {
        return this.$message.warning('请输入分类名称!');
      }
      // console.log('this.customerCopy', this.customerCopy);
    },
    submitAddForm () {
      if (!this.addruleForm.labeltype) {
        return this.$message.warning('请先选择或新增标签分类!');
      }
      if (this.dynamicTags.length === 0) {
        return this.$message.warning('请添加标签名称!');
      }
      this.customerCopy = JSON.parse(JSON.stringify(this.customerCopy).replace(/corpTags/g, 'tag').replace(/tagId/g, 'id').replace(/tagName/g, 'name'));
      http.addLabelSave(this.customerCopy).then((res) => {
        if (res.success) {
          this.labelVisible = false;
          this.getLabelList();
        }
      });
    },
    resetAdd () {
      this.labelVisible = false;
      this.getLabelList();
    }
  }
};
</script>

<style lang="scss" scoped>
#customerCarInfo{min-width: 800px;min-height:900px; margin-left: 60px;}
.opretaBtn{position:fixed;bottom:0;right:0;padding-right:60px;padding-bottom:15px;display:flex;justify-content: flex-end;margin-bottom:15px;}
.container{padding: 10px;}
.el-tag{margin-right:8px; margin-bottom:5px;}
.tagTitle{margin-bottom:10px; margin-top:10px;}
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .addType{
    margin-top:15px;
  }
  .flexEnd{
    display: flex;
    justify-content: flex-end;
    margin-right:20px;
  }
  .typebox{
    display: flex;
    flex-direction: row;
    min-width: 1000px;
    max-width:1000px;
    border-bottom:1px solid #eeeeee;
  }
  .typeGroup{
    min-width:150px;
    margin-right:10px;
  }
  .typeTag{
    min-width:850px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    overflow-x: scroll;
   small{
      margin-left:8px;
   }
  }
</style>



// WEBPACK FOOTER //
// src/components/customerCheck/userLabelManage.vue